import { useEffect, type JSX } from 'react';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import i18n from './i18n/config';
import { initThemeFromStorage } from './lib/theme';
import { router } from './router';

// React Query client. Defaults are intentionally conservative — tweak per
// resource as real queries are wired up.
// TODO(F2.5-C): set per-resource staleTime and add the React Query Devtools.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

/**
 * App root: providers (React Query + i18next) wrap the React Router instance.
 * The router file (`./router.tsx`) owns the route tree so this file stays a
 * thin shell of cross-cutting concerns.
 */
export default function App(): JSX.Element {
  useEffect(() => {
    initThemeFromStorage();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
      </I18nextProvider>
    </QueryClientProvider>
  );
}
